import { indigo } from "@material-ui/core/colors";
import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  table: {},
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  tTruncate: {
    display: "inline-block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "350px",
  },
  link: {
    textDecoration: "none",
    color: "white",
  },
  hover: {
    cursor: "pointer",
    "& .MuiTableCell-root": {
      fontFamily: "Lato",
      fontWeight: 400,
      lineHeight: "24px",
      fontSize: theme.typography.pxToRem(16),
    },
  },
  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  newFlex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
  },
  tableContainer: {
    boxShadow: "none",
    borderRadius: "0",
    margin: "20px 0",
  },
  searchRow: {
    backgroundColor: theme.palette.background.paper,
    "& .MuiPaper-root .MuiGrid-root": {
      justifyContent: "end",
    },
  },
  navFlex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "start",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse",
    },
  },
  optionsIcon: {
    margin: "0 12px",
    cursor: "pointer",
  },
  downloadIcon: {
    margin: "0 12px",
    cursor: "pointer",
  },
  lockIcon: {
    marginRight: "12px",
  },
  nameIcon: {
    marginRight: 16,
  },
  noFiles: {
    margin: "24px 30px",
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
  },
  flexHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  prevLocationStyle: {
    fontFamily: "Lato",
    fontWeight: 400,
    color: indigo[500],
    cursor: "pointer",
  },
  homeLocation: {
    fontFamily: "Lato",
    fontWeight: 400,
    color: "#A2A9BD",
  },
  separator: {
    margin: "0 10px",
  },
  actualLocation: {
    fontFamily: "Lato",
    fontWeight: 700,
    color: theme.palette.common.black,
  },
  deleteDialog: {
    "& .MuiDialog-container .MuiDialog-paper": {
      [theme.breakpoints.up("md")]: {
        width: "576px",
        "& .MuiDialogActions-root": {
          padding: "8px 32px 40px 32px",
        },
      },
      "& .MuiDialogTitle-root": {
        padding: "36px 0 8px 24px",
        "& .MuiTypography-root": {
          fontFamily: "Lato",
          fontSize: theme.typography.pxToRem(20),
          color: theme.palette.common.black,
        },
      },
      "& .MuiDialogContent-root .MuiDialogContentText-root": {
        fontFamily: "Lato",
        fontSize: theme.typography.pxToRem(16),
        color: theme.palette.common.black,
        overflowWrap: "break-word",
      },
      "& .MuiDialogActions-root": {
        "& button:first-child": {
          fontFamily: "Inter",
          fontWeight: "600",
          fontSize: theme.typography.pxToRem(14),
          border: "none",
          padding: "10px 30px",
          borderRadius: "28px",
          backgroundColor: "inherit",
          color: theme.palette.primary.dark,
          textTransform: "none",
          "&:hover": {
            color: theme.palette.primary.dark,
            backgroundColor: indigo[50],
          },
        },
        "& button:last-child": {
          textTransform: "none",
          fontFamily: "Inter",
          fontWeight: "600",
          fontSize: theme.typography.pxToRem(14),
          padding: "10px 30px",
          borderRadius: "28px",
          border: "none",
          backgroundColor: indigo[500],
          "&:hover": {
            backgroundColor: indigo[500],
            opacity: "90%",
          },
        },
      },
    },
  },
  navDiv: {
    marginTop: 12,
  },
}));
